import type {
  CommonProps as RsCommonProps,
  MultiValueProps as RsMultiValueProps,
  OptionProps as RsOptionProps,
  GroupBase as RsGroupType,
  Props as RsProps,
  SingleValueProps as RsSingleValueProps,
  DropdownIndicatorProps as RsIndicatorProps,
  ControlProps as RsControlProps,
  SelectComponentsConfig as RsSelectComponentsConfig,
  OnChangeValue,
} from 'react-select';
import { UserStatus } from 'api/models';
import type { Color } from 'components/colors';

export interface OptionTypeBase {
  [key: string]: any;
}

export interface CustomOption<Extra = any> extends OptionTypeBase {
  label: string;
  value: string | number;
  color?: Color;
  description?: string;
  imageUrl?: string;
  logoUrl?: string;
  extra?: Extra;
  parent?: string;
  userStatus?: UserStatus;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  __isNew__?: boolean;
  options?: any;
  userGroup?: 'inProject' | 'notInProject';
}

export interface BaseSelectProps {
  type?: SelectMode;
  options?: readonly CustomOption[] | CustomOption[];
}

export interface CustomSelectProps {
  closeMenuOnSelect?: boolean;
  showMenuOnOpen?: boolean;
}

export type OptionWithTeamId = CustomOption<{ teamId: string }>;

export interface GroupType extends RsGroupType<CustomOption> {
  label: string;
}

export type Props<IsMulti extends boolean = false> = RsProps<
  CustomOption,
  IsMulti
>;
export enum OptionType {
  User = 'user',
  Group = 'group',
}

export type SelectType = 'basic' | 'tag' | 'avatar' | 'user';

export interface SelectTypeProp {
  type: SelectType;
}

export type IndicatorProps = RsIndicatorProps<CustomOption, boolean, GroupType>;
export type CommonProps = RsCommonProps<CustomOption, boolean, GroupType>;
export type OptionProps = RsOptionProps<CustomOption, boolean, GroupType>;
export type MultiValueProps = RsMultiValueProps<
  CustomOption,
  boolean,
  GroupType
>;
export type SingleValueProps = RsSingleValueProps<
  CustomOption,
  boolean,
  GroupType
>;
export type DropdownIndicatorProps = IndicatorProps;
export type ControlProps = RsControlProps<CustomOption, boolean, GroupType>;
export type SelectComponentsConfig = RsSelectComponentsConfig<
  CustomOption,
  boolean,
  GroupType
>;

export type ISingleValue<Extra = any> = OnChangeValue<
  CustomOption<Extra>,
  false
>;
export type IMultiValue<Extra = any> = OnChangeValue<CustomOption<Extra>, true>;

export type SingleSelectProps = Props;
export type MultiSelectProps = Props<true>;

export type SelectMode = 'basic' | 'user' | 'tag';
